import React from "react";
import style from "css/solution.module.scss";
import Questions from "components/app/questions";
import SEOMeta from "components/app/SEOMeta";
import Consult from "components/device/neat/consult";
import { useMediaQuery } from "react-responsive";

function DeviceOne(props) {
  const isMobile = useMediaQuery({ query: "(max-width: 889px)" });
  const isTablet = useMediaQuery({
    query: "(min-width: 890px) and (max-width: 1599px)",
  });
  return (
    <>
      <SEOMeta
        title="Device One, 리브테크놀로지"
        description="리브테크놀로지 riv Technolohy - Device One"
        keywords="리브테크놀로지, 리브테크, 리브, riv, riv Technology, neat, 스마트 회의실, 화상회의, Device One, 스마트 강의 컨트롤 시스템"
      />
      <div className={style.content}>
        <div className={style.title_area}>
          <img
            alt="deviceOne"
            src={
              !isMobile && !isTablet
                ? `${process.env.REACT_APP_CLIENT_URL}img/solution/deviceOne/device_one_title.png`
                : `${process.env.REACT_APP_CLIENT_URL}img/solution/deviceOne/device_one_title_m.png`
            }
          />
          <div className={style.title_wrap}>
            <div className={style.title}>
              <span>스마트 강의 컨트롤 시스템</span>
              <img
                alt="deviceOne"
                src={`${process.env.REACT_APP_CLIENT_URL}img/solution/deviceOne/device_one_logo.png`}
              />
            </div>
            <div className={style.title_feature_list_wrap}>
              <div className={style.title_feature_description}>
                화상장비 컨트롤 시스템을 통해 최적의 학습 환경을 경험하세요.
              </div>
              <div className={style.title_feature_list}>
                <div className={style.title_feature_list_item}>
                  <div className={style.title_feature_icon_box}>
                    <img
                      alt="deviceOne"
                      src={`${process.env.REACT_APP_CLIENT_URL}img/solution/deviceOne/batch_control.png`}
                    />
                  </div>
                  <div className={style.title_feature_text}>
                    <span>일괄 제어 기능</span>
                    <span>하나의 버튼 클릭으로 강의 시작/종료.</span>
                  </div>
                </div>
                <div className={style.title_feature_list_item}>
                  <div className={style.title_feature_icon_box}>
                    <img
                      alt="deviceOne"
                      src={`${process.env.REACT_APP_CLIENT_URL}img/solution/deviceOne/anywhere.png`}
                    />
                  </div>
                  <div className={style.title_feature_text}>
                    <span>언제 어디서든 가능</span>
                    <span>시간과 장소에 구애 받지 않고 강의 참여 가능.</span>
                  </div>
                </div>
                <div className={style.title_feature_list_item}>
                  <div className={style.title_feature_icon_box}>
                    <img
                      alt="deviceOne"
                      src={`${process.env.REACT_APP_CLIENT_URL}img/solution/deviceOne/each_control.png`}
                    />
                  </div>
                  <div className={style.title_feature_text}>
                    <span>장비 개별 제어</span>
                    <span>강의 중 마이크/비디오 컨트롤 가능.</span>
                  </div>
                </div>
                <div className={style.title_feature_list_item}>
                  <div className={style.title_feature_icon_box}>
                    <img
                      alt="deviceOne"
                      src={`${process.env.REACT_APP_CLIENT_URL}img/solution/deviceOne/multi_platform.png`}
                    />
                  </div>
                  <div className={style.title_feature_text}>
                    <span>멀티플랫폼 지원</span>
                    <span>Zoom / Webex / Cisco 등 다양하게 호환 가능.</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={style.features_wrap}>
          <div className={style.features_title}>
            유연하고 편리한 <span>Device Control System</span>
            <p>
              {!isMobile && !isTablet
                ? "다양한 화상강의 장비를 일괄적으로 컨트롤 할 수 있는\nDesktop App 입니다."
                : "다양한 화상강의 장비를 일괄적으로\n 컨트롤 할 수 있는 Desktop App 입니다."}
            </p>
          </div>
          <div className={style.features_list}>
            {/* fade-in 효과 넣어야함 */}
            <div className={style.features_list_item}>
              <div className={style.features_img_wrap}>
                <img
                  src={`${process.env.REACT_APP_CLIENT_URL}img/solution/deviceOne/feature_1.png`}
                  alt="feature1"
                />
              </div>
              <div className={style.features_text_wrap}>
                <div className={style.features_label_wrap}>
                  <div className={style.features_item_index}>1</div>
                  <div className={style.features_item_label}>
                    <span>언제 어디서든 쉽게</span> 강의에 참여
                  </div>
                </div>
                <div className={style.features_text}>
                  {!isMobile && !isTablet
                    ? "시간과 장소에 구애받지 않고 학습자가 강의에 참여할 수 있습니다.\n교수자는 간단한 강의 시작/종료 버튼을 통해 모든 장비를 손쉽게\n제어할 수 있어 강의 준비와 마무리가 더욱 간편합니다."
                    : "시간과 장소에 구애받지 않고 학습자가 강의에 참여할 수 있습니다.\n교수자는 간단한 강의 시작/종료 버튼을 통해 모든 장비를 손쉽게 제어할 수 있어 강의 준비와 마무리가 더욱 간편합니다."}
                </div>
              </div>
            </div>

            <div className={style.features_list_item}>
              <div className={style.features_img_wrap}>
                <img
                  src={`${process.env.REACT_APP_CLIENT_URL}img/solution/deviceOne/feature_2.png`}
                  alt="feature2"
                />
              </div>
              <div className={style.features_text_wrap}>
                <div className={style.features_label_wrap}>
                  <div className={style.features_item_index}>2</div>
                  <div className={style.features_item_label}>
                    화상강의 장비 <span>통합 컨트롤 기능</span>
                  </div>
                </div>
                <div className={style.features_text}>
                  {!isMobile && !isTablet
                    ? "Neat Bar · Bar Pro · Board 등 강의실 내 모든 화상장비를 한 번에\n활성화하거나 종료할 수 있습니다. 강의 중 각 장비의 마이크와 비디오를\n개별적으로 제어할 수 있어 유연한 강의 운영이 가능합니다."
                    : "Neat Bar · Bar Pro · Board 등 강의실 내 모든 화상\n장비를 한 번에 활성화하거나 종료할 수 있습니다. 강의 중 각 장비의 마이크와 비디오를 개별적으로 제어할 수 있어 유연한 강의 운영이 가능합니다."}
                </div>
              </div>
            </div>

            <div className={style.features_list_item}>
              <div className={style.features_img_wrap}>
                <img
                  src={`${process.env.REACT_APP_CLIENT_URL}img/solution/deviceOne/feature_3.png`}
                  alt="feature3"
                />
              </div>
              <div className={style.features_text_wrap}>
                <div className={style.features_label_wrap}>
                  <div className={style.features_item_index}>3</div>
                  <div className={style.features_item_label}>
                    <span>멀티플랫폼</span> 지원
                  </div>
                </div>
                <div className={style.features_text}>
                  {!isMobile && !isTablet
                    ? "Zoom · WebEx · Cisco 등 다양한 화상회의 플랫폼을 지원하여\n학습자와 교수자 모두에게 최적의 환경을 제공합니다."
                    : "Zoom · WebEx · Cisco 등 다양한 화상회의 플랫폼을 지원하여 학습자와 교수자 모두에게 최적의 환경을 제공합니다."}
                </div>
              </div>
            </div>

            <div className={style.features_list_item}>
              <div className={style.features_img_wrap}>
                <img
                  src={`${process.env.REACT_APP_CLIENT_URL}img/solution/deviceOne/feature_4.png`}
                  alt="feature4"
                />
              </div>
              <div className={style.features_text_wrap}>
                <div className={style.features_label_wrap}>
                  <div className={style.features_item_index}>4</div>
                  <div className={style.features_item_label}>
                    <span>직관적인 대시보드로</span> 장비 상태 관리
                  </div>
                </div>
                <div className={style.features_text}>
                  {!isMobile && !isTablet
                    ? "실시간으로 모든 장비의 상태를 확인할 수 있는 대시보드를 제공합니다.\n이를 통해 강의 도중 발생할 수 있는 기술적 문제를 신속히 해결하고\n안정적인 학습 환경을 유지할 수 있습니다."
                    : "실시간으로 모든 장비의 상태를 확인할 수 있는 대시보드를 제공합니다.\n이를 통해 강의 도중 발생할 수 있는 기술적 문제를 신속히 해결하고 안정적인 학습 환경을 유지할 수 있습니다."}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={style.advantage_wrap}>
        <div className={style.advantage_title_wrap}>
          <div className={style.advantage_title}>
            언제 어디서든 학습하고
            <br />
            <span>화상강의 장비를 컨트롤</span> 하세요!
          </div>
          <p>
            {!isMobile && !isTablet
              ? "화상장비 컨트롤 시스템은 언제 어디서든 원활하게 수강하고 참여할 수 있는 유연성을 제공하며\n다양한 플랫폼을 지원하여 사용자의 편의성을 고려하였으며\n대시보드를 통해 모든 장비의 상태를 실시간으로 모니터링하고 관리할 수 있습니다."
              : "화상장비 컨트롤 시스템은\n 언제 어디서든 원활하게 수강하고\n 참여할 수 있는 유연성을 제공하며\n다양한 플랫폼을 지원하여\n 사용자의 편의성을 고려하였으며\n대시보드를 통해 모든 장비의 상태를\n 실시간으로 모니터링하고 관리할 수 있습니다."}
          </p>
        </div>

        <div className={style.advantage_list_wrap}>
          <div className={style.advantage_list_item}>
            <div className={style.advantage_item_icon_wrap}>
              <div className={style.advantage_item_icon_box}>
                <img
                  alt="integration"
                  src={`${process.env.REACT_APP_CLIENT_URL}img/solution/deviceOne/integration.png`}
                />
              </div>
            </div>
            <div className={style.advatage_title}>
              <span>Integration</span>
              <span>통합성</span>
            </div>
            <div className={style.advatage_text}>
              {!isMobile && !isTablet
                ? "스마트 강의 컨트롤 시스템은 다양한 화상회의 장비와 소프트웨어를\n하나의 플랫폼에서 통합적으로 관리할 수 있도록 설계되었습니다.\n교수자와 학생 모두가 통합된 환경에서 강의를 진행하고 참여할 수\n있습니다. 모든 장비가 일괄적으로 제어되며, 강의 준비 시간과 관리\n부담이 크게 줄어듭니다."
                : "스마트 강의 컨트롤 시스템은 다양한 화상회의 장비와 소프트웨어를 하나의 플랫폼에서 통합적으로 관리할 수 있도록 설계되었습니다.\n교수자와 학생 모두가 통합된 환경에서 강의를 진행하고 참여할 수 있습니다. 모든 장비가 일괄적으로 제어되며, 강의 준비 시간과 관리 부담이 크게 줄어듭니다."}
            </div>
          </div>
          <div className={style.advantage_list_item}>
            <div className={style.advantage_item_icon_wrap}>
              <div className={style.advantage_item_icon_box}>
                <img
                  alt="flexibility"
                  src={`${process.env.REACT_APP_CLIENT_URL}img/solution/deviceOne/flexibility.png`}
                />
              </div>
            </div>
            <div className={style.advatage_title}>
              <span>Flexibility</span>
              <span>유연성</span>
            </div>
            <div className={style.advatage_text}>
              {!isMobile && !isTablet
                ? "이 시스템은 온·오프라인 하이브리드 환경을 지원하며, 학습자가 시간과\n장소의 제약 없이 강의에 참여할 수 있도록 유연한 학습 환경을 제공\n합니다. 또한, 교수자는 강의 중 각 장비의 마이크, 비디오 등을\n개별적으로 활성화하거나 비활성화할 수 있어 상황에 맞는 유연한 강의\n운영이 가능합니다."
                : "이 시스템은 온·오프라인 하이브리드 환경을 지원하며, 학습자가 시간과 장소의 제약 없이 강의에 참여할 수 있도록 유연한 학습 환경을 제공합니다. 또한, 교수자는 강의 중 각 장비의 마이크, 비디오 등을 개별적으로 활성화하거나 비활성화할 수 있어 상황에 맞는 유연한 강의 운영이 가능합니다."}
            </div>
          </div>
          <div className={style.advantage_list_item}>
            <div className={style.advantage_item_icon_wrap}>
              <div className={style.advantage_item_icon_box}>
                <img
                  alt="scalability"
                  src={`${process.env.REACT_APP_CLIENT_URL}img/solution/deviceOne/scalability.png`}
                />
              </div>
            </div>
            <div className={style.advatage_title}>
              <span>Scalability</span>
              <span>확장성</span>
            </div>
            <div className={style.advatage_text}>
              {!isMobile && !isTablet
                ? "스마트 강의 컨트롤 시스템은 단일 강의실뿐만 아니라 여러 강의실과\n캠퍼스 전체로 확장 가능합니다. 강의실의 수나 장비의 종류에 상관없이\n동일한 플랫폼으로 관리가 가능하며, 추가적인 장비나 기능이 필요할\n경우에도 쉽게 확장할 수 있습니다. 이는 학교 규모의 성장과 새로운\n기술 도입에 유연하게 대응할 수 있도록 지원합니다."
                : "스마트 강의 컨트롤 시스템은 단일 강의실뿐만 아니라 여러 강의실과 캠퍼스 전체로 확장 가능합니다.\n 강의실의 수나 장비의 종류에 상관없이 동일한\n 플랫폼으로 관리가 가능하며, 추가적인 장비나 기능이 필요할 경우에도 쉽게 확장할 수 있습니다. 이는 학교 규모의 성장과 새로운 기술 도입에 유연하게 대응할 수 있도록 지원합니다."}
            </div>
          </div>
          <div className={style.advantage_list_item}>
            <div className={style.advantage_item_icon_wrap}>
              <div className={style.advantage_item_icon_box}>
                <img
                  alt="convenience"
                  src={`${process.env.REACT_APP_CLIENT_URL}img/solution/deviceOne/convenience.png`}
                />
              </div>
            </div>
            <div className={style.advatage_title}>
              <span>Convenience</span>
              <span>편리성</span>
            </div>
            <div className={style.advatage_text}>
              {!isMobile && !isTablet
                ? "사용자 친화적인 인터페이스와 간단한 조작으로, 강의 시작과 종료를\n버튼 하나로 제어할 수 있습니다. 학생들은 고정된 URL이나 Zoom\nID만으로 강의실에 간편히 접속할 수 있어 복잡한 설정 없이 빠르게\n참여할 수 있습니다."
                : "사용자 친화적인 인터페이스와 간단한 조작으로, 강의 시작과 종료를 버튼 하나로 제어할 수 있습니다. 학생들은 고정된 URL이나 Zoom ID만으로 강의실에 간편히 접속할 수 있어 복잡한 설정 없이 빠르게 참여할 수 있습니다."}
            </div>
          </div>
          <div className={style.advantage_list_item}>
            <div className={style.advantage_item_icon_wrap}>
              <div className={style.advantage_item_icon_box}>
                <img
                  alt="efficiency"
                  src={`${process.env.REACT_APP_CLIENT_URL}img/solution/deviceOne/efficiency.png`}
                />
              </div>
            </div>
            <div className={style.advatage_title}>
              <span>Efficiency</span>
              <span>효율성</span>
            </div>
            <div className={style.advatage_text}>
              {!isMobile && !isTablet
                ? "대시보드를 통해 실시간 장비 상태를 모니터링하고 문제를 즉각적으로\n해결할 수 있어, 강의 중단이나 기술적 장애를 최소화합니다. 또한,\n강의 준비 시간과 장비 설정 과정을 간소화하여 교수자의 부담을\n줄이고, 학습자에게는 끊김 없는 강의 경험을 제공합니다."
                : "대시보드를 통해 실시간 장비 상태를 모니터링하고 문제를 즉각적으로 해결할 수 있어, 강의 중단이나 기술적 장애를 최소화합니다. 또한, 강의 준비 시간과 장비 설정 과정을 간소화하여 교수자의 부담을 줄이고, 학습자에게는 끊김 없는 강의 경험을 제공합니다."}
            </div>
          </div>
        </div>
      </div>

      <div
        className={style.slogan_wrap}
        style={{
          backgroundImage:
            !isMobile && !isTablet
              ? `url('${process.env.REACT_APP_CLIENT_URL}img/solution/deviceOne/device_one_bg.png')`
              : `url('${process.env.REACT_APP_CLIENT_URL}img/solution/deviceOne/device_one_bg_m.png')`,
        }}
      >
        <div
          className={style.slogan_box}
          style={{
            backgroundImage:
              !isMobile && !isTablet
                ? `url('${process.env.REACT_APP_CLIENT_URL}img/solution/deviceOne/device_one_bg2.png')`
                : `url('${process.env.REACT_APP_CLIENT_URL}img/solution/deviceOne/device_one_bg2.png')`,
          }}
        >
          <div>
            유연한 학습과{"\n"} 편리한 장비 제어를 위한{"\n"}{" "}
            <span>맞춤형 시스템!</span>
          </div>
          <p>
            학교 환경에 최적화된 솔루션을 제공하며,
            <br />
            상담을 통해 더 자세히 알아보실 수 있습니다.
          </p>
        </div>
      </div>
      {props.type === "popup" ? (
        <div style={{ marginBottom: "70px" }}>
          <Consult />
        </div>
      ) : (
        <div className={style.device_consult_wrapper}>
          <Questions />
        </div>
      )}
    </>
  );
}

export default DeviceOne;
